export const CPMSessionDay = (() => {
	const _usageDate = Symbol();
	const _maxExtension = Symbol();
	const _maxFlexion = Symbol();
	const _averageSessionTime = Symbol();
	const _totalUsageTime = Symbol();

	const coalesce = (...args) => {
		return args.find(arg => arg !== undefined);
	};

	class CPMSessionDay {
		constructor(usageDate, maxExtension, maxFlexion, averageSessionTime, totalUsageTime) {
			this.usageDate = usageDate;
			this.maxExtension = maxExtension;
			this.maxFlexion = maxFlexion;
			this.averageSessionTime = averageSessionTime;
			this.totalUsageTime = totalUsageTime;
		}
		get usageDate() {
			return this[_usageDate];
		}
		set usageDate(v) {
			if(!Number.isInteger(v))
				throw new TypeError('usageDate must be an integer.');
			this[_usageDate] = v;
		}
		get maxExtension() {
			return this[_maxExtension];
		}
		set maxExtension(v) {
			if(v !== null && !Number.isInteger(v))
				throw new TypeError('maxExtension must be an integer.');
			this[_maxExtension] = v;
		}
		get maxFlexion() {
			return this[_maxFlexion];
		}
		set maxFlexion(v) {
			if(v !== null && !Number.isInteger(v))
				throw new TypeError('maxFlexion must be an integer.');
			this[_maxFlexion] = v;
		}
		get averageSessionTime() {
			return this[_averageSessionTime];
		}
		set averageSessionTime(v) {
			if(v !== null && !Number.isInteger(v))
				throw new TypeError('averageSessionTime must be an integer.');
			this[_averageSessionTime] = v;
		}
		get totalUsageTime() {
			return this[_totalUsageTime];
		}
		set totalUsageTime(v) {
			if(v !== null && !Number.isInteger(v))
				throw new TypeError('totalUsageTime must be an integer.');
			this[_totalUsageTime] = v;
		}
		toJSON() {
			return {
				usageDate: this.usageDate,
				maxExtension: this.maxExtension,
				maxFlexion: this.maxFlexion,
				averageSessionTime: this.averageSessionTime,
				totalUsageTime: this.totalUsageTime
			};
		}
		static fromObject(obj) {
			if(obj === null || typeof obj !== 'object')
				throw new TypeError('obj must be an object.');
			
			return new this(
				(obj.usageDate || obj.UsageDate) instanceof Date ? 
					(obj.usageDate || obj.UsageDate).getTime() : 
					(obj.usageDate || obj.UsageDate)
					|| null,
				coalesce(obj.maxExtension, obj.MaxExtension, null),
				coalesce(obj.maxFlexion, obj.MaxFlexion, null),
				coalesce(obj.averageSessionTime, obj.AverageSessionTime, null),
				coalesce(obj.totalUsageTime, obj.TotalUsageTime, null)
			);
		}
	}

	return CPMSessionDay;
})();

export const CPMSessionDaily = (() => {
	const _items = Symbol();

	class CPMSessionDaily {
		constructor(...items) {
			this[_items] = [];
			this.add(...items);
		}
		//iterator protocol support
		*iterator() {
			for(let key in this[_items]) {
				let value = this[_items][key];
				yield value;
			}
		}
		//iterable protocol support
		[Symbol.iterator]() {
			return this.iterator();
		}
		add(...items) {
			items.forEach((item, index) => {
				if(!(item instanceof CPMSessionDay))
					throw new TypeError(`argument at index ${index} must be an instance of CPMSessionDay.`);
			});
			this[_items].push(...items);
		}
		get(index) {
			if(!Number.isInteger(index))
				throw new TypeError('index must be an integer.');
			
			return this[_items][index];
		}
		get length() {
			return this[_items].length;
		}
		get firstDay() {
			return this[_items].reduce((p, c) => {
				if(!p) return c;
				return p.usageDate < c.usageDate ? p : c;
			}, null);
		}
		get lastDay() {
			return this[_items].reduce((p, c) => {
				if(!p) return c;
				return p.usageDate > c.usageDate ? p : c;
			}, null);
		}
		toJSON() {
			return this[_items].slice(0);
		}
		static fromArray(arr) {
			if(!Array.isArray(arr))
				throw new TypeError('arr must be an array.');
			return new this(
				...arr.map(v => CPMSessionDay.fromObject(v))
			);
		}
	}
	return CPMSessionDaily;
})();